import { Observable } from 'rxjs';
import { first, skipWhile, take } from 'rxjs/operators';
import { CheckVersionUseCase } from 'src/app/use-case/ms-api/check-version/check-version.use-case';
import { CheckVersionEvent } from 'src/app/use-case/ms-api/check-version/utils/check-version.utils';
import { GetConfigUseCase } from 'src/app/use-case/ms-api/config/get-config.use-case';
import { ConfigEvent } from 'src/app/use-case/ms-api/config/utils/get-config.utils';
import { UpdateConfigUseCase } from 'src/app/use-case/update-configuration/update-config.use-case';
import { UpdateConfigEvent } from 'src/app/use-case/update-configuration/utils/update-config.models';
import { MSStandardEvent } from 'src/app/utils/event/standard.utils';

export async function configExecuteAsPromise(authCode: string, configUseCase: GetConfigUseCase): Promise<ConfigEvent.Spec> {
  const configEventPromise = configUseCase.eventStream
    .pipe(
      skipWhile((event) => event instanceof ConfigEvent.Loading),
      take(1)
    )
    .toPromise();
  configUseCase.execute(authCode);

  const configEvent = await configEventPromise;
  return configEvent;
}

export async function updateConfigExecuteAsPromise(
  accessCode: string,
  updateConfigUseCase: UpdateConfigUseCase
): Promise<UpdateConfigEvent.Spec> {
  const updateConfigPromise = standardEventAsPromise(updateConfigUseCase.eventStream);
  updateConfigUseCase.execute(accessCode);

  const updateConfigResponse = await updateConfigPromise;
  return updateConfigResponse;
}

export async function checkVersionExecuteAsPromise(checkVersionUseCase: CheckVersionUseCase): Promise<CheckVersionEvent.Spec> {
  const checkVersionEventPromise = checkVersionUseCase
    .execute()
    .pipe(
      skipWhile((event) => event instanceof CheckVersionEvent.Loading),
      take(1)
    )
    .toPromise();

  const checkVersionEvent = await checkVersionEventPromise;
  return checkVersionEvent;
}

export async function standardEventAsPromise<T>(observable: Observable<T>): Promise<T> {
  const promise = observable.pipe(
      skipWhile((event) => event instanceof MSStandardEvent.Loading),
      take(1)
    )
    .toPromise();

  const value = await promise;
  return value;
}

export async function observableAsPromise<T>(observable: Observable<T>): Promise<T> {
  const promise = observable.pipe(
    first()
  ).toPromise();

  return promise;
}